!(function (algolia, $, _, Shopify) {
    "use strict";
    algolia.config.powered_by && console.log("You're using Algolia !\nVisit https://www.algolia.com/ for more insight about what we do."),
        (algolia.$ = algolia.jQuery = $.noConflict(!0)),
        (algolia._ = algolia.underscore = algolia.lodash = _.noConflict()),
        (algolia.storeName = window.location.hostname.replace(/^www\./, "").replace(/^([^.]*)\..*$/, "$1")),
        (algolia.client = algoliasearch(algolia.config.app_id, algolia.config.search_api_key)),
        (algolia.templates = {}),
        (algolia.indices = {}),
        (algolia.full_results = window.location.href.match(/\/search/)),
        (algolia.is_collection_results_page = !!window.location.pathname.match(/^\/collections\/(?!all$)([^/]+)[/]*$/)),
        (algolia.hoganOptions = { delimiters: "[[ ]]" }),
        (algolia.getTemplate = function (name) {
            return document.getElementById("template_algolia_" + name).innerHTML;
        }),
        (algolia.compileTemplate = function (name) {
            return Hogan.compile(algolia.getTemplate(name), algolia.hoganOptions);
        }),
        (algolia.render = function (template, obj) {
            return (obj = _.assign({}, obj, { helpers: algolia.hoganHelpers })), template.render(obj);
        }),
        (algolia.appendStyle = function (content) {
            var newNode,
                referenceNode,
                scripts = document.getElementsByTagName("script"),
                currentScript = scripts[scripts.length - 1],
                style = document.createElement("style");
            (style.innerHTML = content), (newNode = style), (referenceNode = currentScript).parentNode.insertBefore(newNode, referenceNode.nextSibling);
        }),
        (algolia.money_format = algolia.getTemplate("money_format").replace(/^\s+|\s+$/g, "")),
        (algolia.formatMoney = function (cents) {
            var val = (cents / 100).toLocaleString(void 0, { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                format = algolia.money_format,
                regexp = /^([^{}]*)\{\{amount\}\}([^{}]*)$/;
            return format.match(regexp) ? format.replace(regexp, "$1" + val + "$2") : _.isUndefined(Shopify) || _.isUndefined(Shopify.formatMoney) ? "$" + val : Shopify.formatMoney(cents, format);
        });
})(algoliaShopify, $, _, Shopify),
    (function (algolia) {
        "use strict";
        var e, a, t, i, c;
        algolia.config.analytics_enabled &&
            ((e = window),
            (a = document),
            (t = "script"),
            (e.AlgoliaAnalyticsObject = "aa"),
            (e.aa =
                e.aa ||
                function () {
                    (e.aa.queue = e.aa.queue || []).push(arguments);
                }),
            (i = a.createElement(t)),
            (c = a.getElementsByTagName(t)[0]),
            (i.async = 1),
            (i.src = "https://cdn.jsdelivr.net/npm/search-insights@0.0.14"),
            c.parentNode.insertBefore(i, c),
            aa("init", { applicationID: algolia.config.app_id, apiKey: algolia.config.search_api_key }),
            (algolia.clickTracker = function (e) {
                window.aa("click", { objectID: e.target.getAttribute("data-algolia-objectid"), position: parseInt(e.target.getAttribute("data-algolia-position")), queryID: e.target.getAttribute("data-algolia-queryid") });
            }));
    })(algoliaShopify),
    (function (algolia) {
        "use strict";
        (algolia.translations = {
            search: "Current search",
            noCollectionFound: "No collection found",
            allProducts: "See all products",
            matching: "matching",
            sortBy: "Sort by",
            relevance: "Relevance",
            outOf: "out of",
            resultsFound: "results found",
            oneResultFound: "1 result found",
            noResultFound: "No result found",
            addToCart: "Add to cart",
            searchForProduct: "Search for products",
            selectedFilter: "Selected filters",
            clearAll: "Clear all",
            noPageFound: "No page found",
        }),
            (algolia.translation_helpers = {
                no_result_for: function (text, render) {
                    return "No result for query " + render(text);
                },
                in: function (text, render) {
                    return "in " + render(text) + "s";
                },
                try_clear_or_change_input: function (text, render) {
                    var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, "g"),
                        html_tags = text.match(regex);
                    return "Try " + render(html_tags[0]) + " clearing filters " + render(html_tags[1]) + " or " + render(html_tags[2]) + " changing your input " + render(html_tags[3]);
                },
                outOf: function (text, render) {
                    return render(text) + " out of";
                },
                by: function (text, render) {
                    return "by " + render(text);
                },
            });
    })(algoliaShopify),
    (function (algolia) {
        "use strict";
        var _ = algolia._,
            formatPrice = function (value) {
                return algolia.formatMoney(100 * +value);
            };
        function formattedPriceWithComparison(price, compare_at_price, price_ratio) {

            var comparing = +compare_at_price && +price < +compare_at_price,
                discount_ratio = 1 - price_ratio,
                res = "<b>" + formatPrice(price) + "</b>";

            return (
                comparing &&
                    ((res += ' <span class="ais-hit--price-striked"><span>' + formatPrice(compare_at_price) + "</span></span> "),
                    (res += ' <span class="ais-hit--price-discount" style="font-weight: ' + 100 * Math.floor(10 * discount_ratio) + ';">-' + Math.floor(100 * discount_ratio) + "%</span>")),
                res
            );
        }
        function formattedLevels(meta) {
            var res = "";
            if (!(meta.global && meta.global["Guided-Reading-Level"] && meta.global["Intervention-Level"])) return res;
            var guided_reading_level = meta.global["Guided-Reading-Level"],
                intervention_level = meta.global["Intervention-Level"],
                g_levels = guided_reading_level.split(",").map(function (value) {
                    return value.trim();
                });
            g_levels = g_levels.sort();
            var i_levels = intervention_level;
            return (
                intervention_level instanceof Array == !1 && (i_levels = intervention_level.split(",")),
                (i_levels = (i_levels = i_levels.map(function (value) {
                    return parseInt(value.trim());
                })).sort(function (a, b) {
                    return a - b;
                })),
                1 < g_levels.length && 1 < i_levels.length
                    ? (res = g_levels[0] + "/" + i_levels[0] + " &ndash; " + g_levels[g_levels.length - 1] + "/" + i_levels[i_levels.length - 1])
                    : 1 < g_levels.length && 1 == i_levels.length
                    ? (res = g_levels[0] + "/" + i_levels[0] + " &ndash; " + g_levels[g_levels.length - 1] + "/" + i_levels[0])
                    : 1 == g_levels.length && 1 < i_levels.length
                    ? (res = g_levels[0] + "/" + i_levels[0] + " &ndash; " + g_levels[0] + "/" + i_levels[i_levels.length - 1])
                    : 1 == g_levels.length && 1 == i_levels.length && (res = g_levels[0] + "/" + i_levels[0]),
                res
            );
        }
        (algolia.helpers = {
            formatNumber: function (text, render) {
                return Number(render(text)).toLocaleString();
            },
            formattedPrice: function (text, render) {
                return formatPrice(render(text));
            },
            formattedPriceWithoutDecimals: function (text, render) {
                return formatPrice(render(text)).replace(/\.\d+$/, "");
            },
            autocompletePrice: function (text, render) {

                if (this._distinct) {
                  
                    var min = this.variants_min_price,
                        max = this.variants_max_price;
                    if (min !== max) return "<b>" + formatPrice(min) + " - " + formatPrice(max) + "</b>";
                }
                return formattedPriceWithComparison(this.price, null);
            },
            instantsearchPrice: function (text, render) {
              
                if (this._distinct) {

                    var min = this.variants_min_price,
                        max = this.variants_max_price;
                    if (min !== max) return "<b>" + formatPrice(min) + " - " + formatPrice(max) + "</b>";
                }
                
                return formattedPriceWithComparison(this.price, this.compare_at_price, this.price_ratio);
            },

            pvbPrice: function (text, render) {

                var min = this.variants_min_price,
                    max = this.variants_max_price;
              
                if (min !== max) return "<b>" + formatPrice(min) + " - " + formatPrice(max) + "</b>";

                return "<b>" + formatPrice(this.price) + "</b>";
              
               // if (this._distinct) {

               //     var min = this.variants_min_price,
               //         max = this.variants_max_price;
               //     if (min !== max) return "<b>" + formatPrice(min) + " - " + formatPrice(max) + "</b>";
               // }
                
               // return formattedPriceWithComparison(this.price, this.compare_at_price, this.price_ratio);
            },

          
            instantsearchLink: function () {
                var addVariantId = !this._distinct && this.objectID !== this.id;
                //return "/products/" + this.handle + (addVariantId ? "?variant=" + this.objectID : "");
                return "/products/" + this.handle;
            },
            fullTitle: function () {
                var res = this.title;
                return (
                    !this._distinct && this.variant_title && "Default Title" !== this.variant_title && "Default" !== this.variant_title && (res += " (" + this.variant_title + ")"),
                    (function (unsafe) {
                        return (unsafe || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
                    })(res)
                );
            },
            fullHTMLTitle: function () {
                var res = this._highlightResult.title.value;
                return (
                    !this._distinct && this.variant_title && "Default Title" !== this.variant_title && "Default" !== this.variant_title && (res += ' <span class="algolia-variant">(' + this._highlightResult.variant_title.value + ")</span>"),
                    res
                );
            },
            truncatedBody: function () {
                var res = this.body_html_safe,
                    resArray = res.split(" ");
                return 8 < resArray.length ? resArray.splice(0, 8).join(" ") + "..." : res;
            },
            truncatedBody50Words: function () {
                var res = this.body_html_safe,
                    resArray = res.split(" ");
                return 50 < resArray.length ? resArray.splice(0, 50).join(" ") + "..." : res;
            },
            floor: function (text, render) {
                return "" + Math.floor(+render(text));
            },
            ceil: function (text, render) {
                return "" + Math.ceil(+render(text));
            },
            sizedImage: function (text, render) {
                var image = this._distinct ? this.product_image : this.image;
                if (!image) return "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
                var size = render(text).replace(/^\s+|\s+$/g, "");
                return "original" === size ? image : image.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + size + ".$2");
            },
            levels: function () {
                var res = formattedLevels(this.meta);
                res = res.replace("/NaN", "");
              
                return "" != res && (res = "Levels:" + res), res;
            },
            levelsWithoutLabelHtml: function () {
                var res = formattedLevels(this.meta);
                res = res.replace("/NaN", "");
              
                return "" != res && (res = '<span class="level-chart">' + res + "</span>"), res;
            },
            levelsWithHtml: function () {
                var res = formattedLevels(this.meta);
                res = res.replace("/NaN", "");
            
                return "" != res && (res = 'Levels: <span class="level-chart">' + res + "</span>"), res;
            },
            PVB_levels: function () {
              var res = "";
              if (!(this.meta.custom && this.meta.custom["reading_level"])) return res;
              res = this.meta.custom.reading_level;
              
                return "" != res && (res = "Levels: " + res), res;
            },
            PVB_levelsWithHtml: function () {
              var res = "";
              if (!(this.meta.custom && this.meta.custom["reading_level"])) return res;
              res = this.meta.custom.reading_level;
            
                return "" != res && (res = 'Levels: <span class="level-chart">' + res + "</span>"), res;
            },
            PVB_showLexileLevel: function () {
              var res = "";
              var show_level = this.meta.custom["show_lexile_level"];
              if (show_level == false) {
                res = "hide"
              }
              return res;
            },
            PVB_showReadingLevel: function () {
              var res = "";
              var show_level = this.meta.custom["show_reading_level"];
              if (show_level == false) {
                res = "hide"
              }
              return res;
            },
            formatWordCount: function () {
                var res = "";
                return this.meta.global && this.meta.global["Word-Count"] && (res = this.meta.global["Word-Count"]), res;
            },
        }),
            _.forEach(["pico", "icon", "thumb", "small", "compact", "medium", "large", "grande", "original"], function (size) {
                var _size;
                algolia.helpers[size + "Image"] =
                    ((_size = size),
                    function () {
                        var image = this._distinct ? this.product_image : this.image;
                        return image ? ("original" === _size ? image : image.replace(/\/(.*)\.(\w{2,4})/g, "/$1_" + _size + ".$2")) : "http://cdn.shopify.com/s/images/admin/no-image-compact.gif";
                    });
            }),
            (algolia.hoganHelpers = _.reduce(
                Object.assign({}, algolia.helpers, algolia.translation_helpers),
                function (res, helper, name) {
                    return (
                        (res[name] = function () {
                            return function (text) {
                                var render = function (value) {
                                    return Hogan.compile(value, algolia.hoganOptions).render(this);
                                }.bind(this);
                                return helper.call(this, text, render);
                            }.bind(this);
                        }),
                        res
                    );
                },
                {}
            ));
    })(algoliaShopify),
    (function (algolia) {
        if (algolia.config.autocomplete_enabled) {
            var autocomplete,
                _ = algolia._,
                $ = algolia.jQuery;
            (autocomplete = algolia.autocomplete = {
                articles: {
                    enabled: algolia.config.index_articles,
                    hitsPerPage: algolia.config.articles_autocomplete_hits_per_page,
                    index: index("articles"),
                    templates: { empty: algolia.compileTemplate("autocomplete_articles_empty"), hit: algolia.compileTemplate("autocomplete_article") },
                },
                pages: {
                    enabled: algolia.config.index_pages,
                    hitsPerPage: algolia.config.pages_autocomplete_hits_per_page,
                    index: index("pages"),
                    templates: { empty: algolia.compileTemplate("autocomplete_pages_empty"), hit: algolia.compileTemplate("autocomplete_page") },
                },
                collections: {
                    enabled: algolia.config.index_collections,
                    hitsPerPage: algolia.config.collections_autocomplete_hits_per_page,
                    index: index("collections"),
                    templates: { empty: algolia.compileTemplate("autocomplete_collections_empty"), hit: algolia.compileTemplate("autocomplete_collection") },
                },
                colors: algolia.config.colors,
                debug: algolia.config.autocomplete_debug,
                poweredBy: algolia.config.powered_by,
                products: {
                    enabled: algolia.config.index_products,
                    distinct: algolia.config.show_products,
                    hitsPerPage: algolia.config.products_autocomplete_hits_per_page,
                    index: index("products"),
                    templates: { empty: algolia.compileTemplate("autocomplete_products_empty"), footer: algolia.compileTemplate("autocomplete_footer"), hit: algolia.compileTemplate("autocomplete_product") },
                },
                selector: algolia.config.input_selector + ", .algolia-shopify-autocomplete",
                showFooter: algolia.config.instant_search_enabled,
                storeName: algolia.storeName,
                templates: { dropdown: algolia.compileTemplate("autocomplete"), empty: "<div></div>", style: algolia.compileTemplate("autocomplete.css") },
            }).poweredBy && console.log("Algolia: Autocomplete"),
                algolia.appendStyle(algolia.render(autocomplete.templates.style, { colors: autocomplete.colors })),
                $(document).ready(function () {
                    (autocomplete.$input = $(autocomplete.selector)),
                        autocomplete.$input.autocomplete(
                            {
                                debug: autocomplete.debug,
                                hint: !1,
                                appendTo: "body",
                                templates: {
                                    dropdownMenu: algolia.render(autocomplete.templates.dropdown, {
                                        storeName: autocomplete.storeName,
                                        with: {
                                            articles: autocomplete.articles.enabled,
                                            collections: autocomplete.collections.enabled,
                                            pages: autocomplete.pages.enabled,
                                            footer: autocomplete.showFooter,
                                            poweredBy: autocomplete.poweredBy,
                                            products: autocomplete.products.enabled,
                                        },
                                    }),
                                    empty: autocomplete.templates.empty,
                                },
                            },
                            _.compact([autocompleteSection("collections"), autocompleteSection("articles"), autocompleteSection("pages"), autocompleteSection("products")])
                        ),
                        autocomplete.$input.each(function () {
                            var touchmoved,
                                dropdown = $(this).data("aaAutocomplete").dropdown,
                                suggestionClass = "." + dropdown.cssClasses.prefix + "-" + dropdown.cssClasses.suggestion,
                                onSuggestionClick = dropdown._onSuggestionClick.bind(dropdown);
                            dropdown.$menu
                                .on("touchend", suggestionClass, function (e) {
                                    !1 === touchmoved && (e.preventDefault(), e.stopPropagation(), onSuggestionClick.apply(this, arguments));
                                })
                                .on("touchmove", function () {
                                    touchmoved = !0;
                                })
                                .on("touchstart", function () {
                                    touchmoved = !1;
                                });
                        }),
                        autocomplete.$input.on("autocomplete:selected", function (obj, datum, name) {
                            if ((algolia.config.analytics_enabled && window.aa("click", { objectID: datum.objectID, position: datum._position, queryID: datum._queryID }), "products" === name)) {
                                var addVariantId = !autocomplete.products.distinct && datum.objectID !== datum.id;
                                window.location.href = "/" + name + "/" + datum.handle + (addVariantId ? "?variant=" + datum.objectID : "");
                            } else window.location.href = "articles" === name ? "/blogs/" + datum.blog.handle + "/" + datum.handle : "/" + name + "/" + datum.handle;
                        }),
                        autocomplete.$input.on("autocomplete:redrawn", function () {
                            readjust($(this));
                        }),
                        $(window).resize(function () {
                            autocomplete.$input.each(function () {
                                readjust($(this));
                            });
                        });
                });
        }
        function index(name) {
            return algolia.client.initIndex("" + algolia.config.index_prefix + name);
        }
        function autocompleteSection(section) {
            var params = autocomplete[section];
            if (!0 !== params.enabled) return null;
            var templates = {
                empty: function (props) {
                    return algolia.render(params.templates.empty, Object.assign({}, props, { translations: algolia.translations }));
                },
                suggestion: function (hit) {
                    return algolia.render(params.templates.hit, Object.assign({ _distinct: params.distinct }, hit, { translations: algolia.translations }));
                },
            };
            return (
                params.templates.footer &&
                    (templates.footer = function (props, content) {
                        return content.nbHits <= params.hitsPerPage
                            ? null
                            : autocomplete.showFooter
                            ? algolia.render(params.templates.footer, { query: props.query, nbHits: content.nbHits, translations: algolia.translations, helpers: algolia.helpers })
                            : null;
                    }),
                {
                    name: section,
                    source: function (query, callback) {
                        var searchOpts = { clickAnalytics: !0, hitsPerPage: params.hitsPerPage, highlightPreTag: '<span class="aa-highlight">', highlightPostTag: "</span>" };
                        params.distinct && (searchOpts.distinct = !0),
                            index(section)
                                .search(query, searchOpts)
                                .then(function (answer) {
                                    var hits = (function (hits, queryID) {
                                        return hits.map(function (entry, index) {
                                            return (entry._position = index + 1), (entry._queryID = queryID), entry;
                                        });
                                    })(answer.hits, answer.queryID);
                                    callback(hits, answer);
                                });
                    },
                    displayKey: "title",
                    templates: templates,
                }
            );
        }
        function readjust($this) {
            var data = $this.data("aaAutocomplete");
            if (data) {
                var $node = data.$node,
                    $dropdown = data.dropdown.$menu,
                    width = $this.outerWidth(),
                    vpWidth = document.body.clientWidth,
                    offset = $this.offset(),
                    left = offset.left,
                    right = vpWidth - width - left,
                    top = offset.top,
                    height = $this.outerHeight(),
                    align = left < right ? "left" : "right",
                    dist = Math.min(left, right);
                vpWidth < 4 * dist && ((align = "left"), (dist = Math.round(vpWidth / 4)));
                var newWidth = vpWidth - 2 * dist;
                600 <= width && ((align = "left"), (dist = left), (newWidth = width)),
                    $node
                        .css("left", "")
                        .css("right", "")
                        .css("top", top + height + 8 + "px")
                        .css(align, dist)
                        .css("width", newWidth + "px");
                var suffix = "lg";
                newWidth < 300 ? (suffix = "xs") : newWidth < 600 ? (suffix = "sm") : newWidth < 900 && (suffix = "md"),
                    $dropdown
                        .removeClass("aa-dropdown-menu-size-xs")
                        .removeClass("aa-dropdown-menu-size-sm")
                        .removeClass("aa-dropdown-menu-size-md")
                        .removeClass("aa-dropdown-menu-size-lg")
                        .addClass("aa-dropdown-menu-size-" + suffix);
            }
        }
    })(algoliaShopify),
    (function (algolia) {
        "use strict";
        var sortFunction,
            _ = algolia._,
            TYPES_TO_WIDGET = {
                slider: { name: "rangeSlider", useDefault: !0 },
                menu: { name: "menu", params: { limit: 10 } },
                conjunctive: { name: "refinementList", params: { operator: "and", limit: 10 } },
                disjunctive: { name: "refinementList", params: { operator: "or", limit: 10 } },
            };
        (algolia.facetSortFunctions = {
            price_range:
                ((sortFunction = function (a, b) {
                    return a.name.length === b.name.length ? a.name.localeCompare(b.name) : a.name.length - b.name.length;
                }),
                function (a, b) {
                    if (a.refined !== b.refined) {
                        if (a.refined) return -1;
                        if (b.refined) return 1;
                    }
                    return sortFunction(a, b);
                }),
        }),
            (algolia.facetDisplayFunctions = {
                price_range: function (value) {
                    var values = value.split(":");
                    return _.map(values, function (e) {
                        return algolia.formatMoney(100 * +e).replace(/\.\d+/, "");
                    }).join(" - ");
                },
            }),
            (algolia.facetCssClasses = {
                root: "ais-facet",
                header: "ais-facet--header",
                body: "ais-facet--body",
                item: "ais-facet--item",
                label: "ais-facet--label",
                checkbox: "ais-facet--checkbox",
                active: "ais-facet--active",
                count: "ais-facet--count",
            });
        var enabledFacets = _.filter(algolia.config.facets, function (facet) {
            return facet.enabled || parseInt(facet.enabled);
        });
        (algolia.facets = _.map(enabledFacets, function (facet) {
            return Object.assign({}, facet, { escapedName: encodeURIComponent(facet.name) });
        })),
            (algolia.shownFacets = _.filter(algolia.facets, function (facet) {
                return "hidden" !== facet.type;
            })),
            (algolia.hiddenFacets = _.filter(algolia.config.facets, function (facet) {
                return "hidden" === facet.type;
            })),
            (algolia.facetTitles = {}),
            _.each(algolia.facets, function (facet) {
                algolia.facetTitles[facet.name] = facet.title;
            }),
            (algolia.facetsWidgets = _.map(algolia.shownFacets, function (facet) {
                var widget = TYPES_TO_WIDGET[facet.type],
                    params = _.cloneDeep(widget.params) || {};
                (params.container = "[class~='ais-facet-" + facet.escapedName + "']"),
                    (params.attributeName = facet.name),
                    (params.templates = {}),
                    (params.cssClasses = algolia.facetCssClasses),
                    facet.searchable &&
                        ((params.searchForFacetValues = { placeholder: "Search for " + facet.name, isAlwaysActive: !0 }), (params.searchForFacetValues.templates = { noResults: "<div> No matching " + facet.name + "</div>" })),
                    (params.templates.header = function () {
                        return facet.title;
                    }),
                    widget.useDefault || (params.templates.item = algolia.getTemplate("instant_search_facet_item")),
                    algolia.facetSortFunctions[facet.name] && (params.sortBy = algolia.facetSortFunctions[facet.name]);
                var displayFunction = algolia.facetDisplayFunctions[facet.name];
                return (
                    (params.transformData = function (data) {
                        return (data.type = {}), (data.type[facet.type] = !0), displayFunction && (data.name = displayFunction(data.name)), data;
                    }),
                    { name: widget.name, params: params }
                );
            }));
    })(algoliaShopify),
    (function (algolia) {
        "use strict";
        var _ = algolia._,
            sort_order_base = algolia.config.index_prefix + "products";
        (algolia.sortOrders = [{ name: sort_order_base, label: "" + algolia.translations.relevance }]),
            _.forEach(algolia.config.sort_orders, function (sort_order) {
                _.isUndefined(sort_order.asc) ||
                    _.isNull(sort_order.asc) ||
                    (!0 !== sort_order.asc.active && "1" !== sort_order.asc.active) ||
                    algolia.sortOrders.push({ name: sort_order_base + "_" + sort_order.key + "_asc", label: sort_order.asc.title }),
                    _.isUndefined(sort_order.desc) ||
                        _.isNull(sort_order.desc) ||
                        (!0 !== sort_order.desc.active && "1" !== sort_order.desc.active) ||
                        algolia.sortOrders.push({ name: sort_order_base + "_" + sort_order.key + "_desc", label: sort_order.desc.title });
            });
    })(algoliaShopify),
    (function (algolia, instantsearch) {
        var collectionFacetConstraint = !!algolia.is_collection_results_page && !!algolia.config.instant_search_enabled_on_collection;
        if ((algolia.full_results || collectionFacetConstraint) && algolia.config.instant_search_enabled) {
            var _ = algolia._,
                $ = algolia.jQuery;
            if (!$(".template-search").length || "advance" !== ((field = "view"), (href = url || window.location.href), (string = new RegExp("[?&]" + field + "=([^&#]*)", "i").exec(href)) ? string[1] : "")) {
                var field,
                    url,
                    href,
                    string,
                    collectionFacetValue = null;
                if (collectionFacetConstraint) {
                    var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
                    matches && 2 === matches.length && (collectionFacetValue = matches[1]);
                }
                algolia.config.results_selector += ", .algolia-shopify-instantsearch";
                var $hiding = $("<style>" + algolia.config.results_selector + " { visibility: hidden }</style>");
                $hiding.appendTo($("head"));
                var instant = (algolia.instantsearch = {
                    colors: algolia.config.colors,
                    distinct: !!algolia.config.show_products,
                    facets: { hidden: algolia.hiddenFacets, shown: algolia.shownFacets, list: algolia.facets, widgets: algolia.facetsWidgets },
                    hitsPerPage: algolia.config.products_full_results_hits_per_page,
                    poweredBy: algolia.config.powered_by,
                    search: instantsearch({
                        appId: algolia.config.app_id,
                        apiKey: algolia.config.search_api_key,
                        indexName: algolia.config.index_prefix + "products",
                        searchParameters: { clickAnalytics: !0 },
                        urlSync: {},
                        searchFunction: function (searchFunctionHelper) {
                            var helper = instant.search.helper,
                                page = helper.getPage();
                            helper.setQueryParameter("highlightPreTag", '<span class="ais-highlight">'),
                                helper.setQueryParameter("highlightPostTag", "</span>"),
                                instant.distinct && helper.setQueryParameter("distinct", !0),
                                collectionFacetConstraint && collectionFacetValue && helper.setQueryParameter("filters", 'collections:"' + collectionFacetValue + '"'),
                                helper.setPage(page),
                                searchFunctionHelper.search();
                        },
                    }),
                    selector: algolia.config.results_selector + ", .algolia-shopify-instantsearch",
                    sortOrders: algolia.sortOrders,
                    storeName: algolia.storeName,
                    templates: {
                        currentItem: algolia.getTemplate("instant_search_current_refined_values_item"),
                        empty: algolia.getTemplate("instant_search_no_result"),
                        page: algolia.compileTemplate("instant_search"),
                        product: algolia.getTemplate("instant_search_product"),
                        stats: algolia.getTemplate("instant_search_stats"),
                        style: algolia.compileTemplate("instant_search.css"),
                    },
                });
                instant.poweredBy && console.log("Algolia: Instant-Search"),
                    _.forEach(Object.assign({}, algolia.helpers, algolia.translation_helpers), function (helper, name) {
                        instant.search.templatesConfig.helpers[name] = helper;
                    }),
                    (instant.search.templatesConfig.compileOptions = algolia.hoganOptions),
                    algolia.appendStyle(algolia.render(instant.templates.style, { distinct: instant.distinct, colors: instant.colors })),
                    $(document).ready(function () {
                        (instant.$results = $(instant.selector)),
                            instant.$results.html(algolia.render(instant.templates.page, { facets: instant.facets.list, storeName: instant.storeName, translations: algolia.translations })),
                            readjust(),
                            $(window).resize(function () {
                                readjust();
                            }),
                            instant.search.addWidget({
                                init: function (opts) {
                                    var $button = $(".ais-facets-button");
                                    $button.on("click", function () {
                                        var $facets = $(".ais-facets");
                                        $facets.hasClass("ais-facets__shown") ? ($button.text("Show filters"), $facets.removeClass("ais-facets__shown")) : ($button.text("Hide filters"), $facets.addClass("ais-facets__shown"));
                                    });
                                },
                            }),
                            instant.search.addWidget(instantsearch.widgets.searchBox({ container: ".ais-search-box-container", placeholder: algolia.translations.searchForProduct, poweredBy: !1 })),
                            instant.search.addWidget({
                                init: function (opts) {
                                    instant.poweredBy || $(".ais-algolia-icon").hide(),
                                        $(".ais-clear-input-icon").on("click", function () {
                                            opts.helper.setQuery("").search(), $(".ais-search-box--input").val("").focus();
                                        });
                                },
                                render: function (opts) {
                                    opts.state.query ? ($(".ais-clear-input-icon").show(), $(".ais-algolia-icon").hide()) : (instant.poweredBy && $(".ais-algolia-icon").show(), $(".ais-clear-input-icon").hide());
                                },
                            }),
                            instant.search.addWidget(
                                instantsearch.widgets.stats({
                                    container: ".ais-stats-container",
                                    templates: { body: instant.templates.stats },
                                    transformData: {
                                        body: function (data) {
                                            return (
                                                (data.processingTimeS = data.processingTimeMS / 1e3),
                                                (data.start = data.page * data.hitsPerPage + 1),
                                                (data.end = Math.min((data.page + 1) * data.hitsPerPage, data.nbHits)),
                                                (data.translations = algolia.translations),
                                                data
                                            );
                                        },
                                    },
                                })
                            ),
                            instant.search.addWidget(instantsearch.widgets.sortBySelector({ container: ".ais-sort-orders-container", indices: instant.sortOrders })),
                            instant.search.addWidget({
                                init: function (opts) {
                                    $(".ais-search-header").on("click", ".ais-change-display-block", function () {
                                        $(".ais-change-display-block:not(.ais-change-display-selected)").addClass("ais-change-display-selected"),
                                            $(".ais-change-display-list.ais-change-display-selected").removeClass("ais-change-display-selected"),
                                            $(".ais-results-as-list").removeClass("ais-results-as-list").addClass("ais-results-as-block");
                                    }),
                                        $(".ais-search-header").on("click", ".ais-change-display-list", function () {
                                            $(".ais-change-display-list:not(.ais-change-display-selected)").addClass("ais-change-display-selected"),
                                                $(".ais-change-display-block.ais-change-display-selected").removeClass("ais-change-display-selected"),
                                                $(".ais-results-as-block").removeClass("ais-results-as-block").addClass("ais-results-as-list");
                                        });
                                },
                            });
                        var list = _.map(instant.facets.hidden, function (facet) {
                            return facet.name;
                        });
                        instant.search.addWidget({
                            getConfiguration: function () {
                                return { facets: list, disjunctiveFacets: list };
                            },
                            init: function () {},
                        });
                        var attributes = _.map(instant.facets.shown, function (facet) {
                            return { name: facet.name, label: facet.title };
                        });
                        instant.search.addWidget(
                            instantsearch.widgets.currentRefinedValues({
                                container: ".ais-current-refined-values-container",
                                cssClasses: { root: "ais-facet", header: "ais-facet--header", body: "ais-facet--body" },
                                templates: { header: algolia.translations.selectedFilter, item: instant.templates.currentItem, clearAll: algolia.translations.clearAll },
                                onlyListedAttributes: !0,
                                attributes: attributes,
                            })
                        ),
                            _.forEach(instant.facets.widgets, function (widget) {
                                instant.search.addWidget(instantsearch.widgets[widget.name](widget.params));
                            }),
                            instant.search.addWidget(
                                instantsearch.widgets.hits({
                                    container: ".ais-hits-container",
                                    hitsPerPage: instant.hitsPerPage,
                                    templates: { empty: instant.templates.empty, item: instant.templates.product },
                                    transformData: {
                                        item: function (product) {
                                            return (
                                                (product._distinct = instant.distinct),
                                                (product.can_order = "shopify" !== product.inventory_management || "continue" === product.inventory_policy || 0 < product.inventory_quantity),
                                                (product.translations = algolia.translations),
                                                (product.queryID = instant.search.helper.lastResults._rawResults[0].queryID),
                                                (product.productPosition = product.__hitIndex + 1),
                                                product
                                            );
                                        },
                                        empty: function (params) {
                                            return (params.translations = algolia.translations), params;
                                        },
                                    },
                                })
                            ),
                            instant.search.addWidget({
                                init: function (opts) {
                                    $(".ais-hits-container").on("click", ".ais-hit", function (e) {
                                        var $this = $(this),
                                            handle = $this.attr("data-handle"),
                                            variant_id = $this.attr("data-variant-id");
                                        distinct = $this.attr("data-distinct");
                                        var link = "/products/" + handle;
                                        "true" !== distinct && (link += "?variant=" + variant_id), algolia.config.analytics_enabled && algolia.clickTracker(e), (window.location.href = link);
                                    }),
                                        $(".ais-hits-container").on("click", ".ais-hit a", function (e) {
                                            e.stopPropagation(), algolia.config.analytics_enabled && algolia.clickTracker(e);
                                        });
                                },
                            }),
                            instant.search.addWidget({
                                init: function (opts) {
                                    $(".ais-hits-container").on("click", ".ais-hit--cart-button", function (e) {
                                        e.stopPropagation();
                                        var formId = $(this).attr("data-form-id");
                                        formId && document.getElementById(formId).submit();
                                    });
                                },
                            }),
                            instant.search.addWidget({
                                init: function (opts) {
                                    $(".ais-hits-container").on("click", ".ais-hit-empty--clear-filters", function () {
                                        var helper = opts.helper;
                                        helper.clearTags(),
                                            _.forEach(instant.facets.list, function (facet) {
                                                helper.clearRefinements(facet.name);
                                            }),
                                            helper.search();
                                    }),
                                        $(".ais-hits-container").on("click", ".ais-hit-empty--clear-input", function () {
                                            opts.helper.setQuery("").search(), $(".ais-search-box--input").val("").focus();
                                        });
                                },
                            }),
                            instant.search.addWidget(instantsearch.widgets.pagination({ container: ".ais-pagination-container", padding: 2, maxPages: 20, showFirstLast: !1, labels: { previous: "Previous", next: "Next" } })),
                            instant.search.start(),
                            $hiding.remove();
                    });
            }
        }
        function readjust() {
            var width = instant.$results.outerWidth(),
                suffix = "lg";
            width < 400 ? (suffix = "xs") : width < 800 ? (suffix = "sm") : width < 1200 && (suffix = "md"),
                instant.$results
                    .removeClass("ais-results-size-xs")
                    .removeClass("ais-results-size-sm")
                    .removeClass("ais-results-size-md")
                    .removeClass("ais-results-size-lg")
                    .addClass("ais-results-size-" + suffix);
        }
    })(algoliaShopify, instantsearch);